import { useState, useEffect } from 'react';

export const useScrollIndicator = () => {
  const [isScrolling, setIsScrolling] = useState(false);

  const handleScroll = () => {
    setIsScrolling(true);
    // Clear any existing timeout
    if (window.scrollIndicatorTimeout) {
      clearTimeout(window.scrollIndicatorTimeout);
    }
    // Hide scrollbar after 1 second of no scrolling
    window.scrollIndicatorTimeout = setTimeout(() => {
      setIsScrolling(false);
    }, 1000);
  };

  useEffect(() => {
    return () => {
      if (window.scrollIndicatorTimeout) {
        clearTimeout(window.scrollIndicatorTimeout);
      }
    };
  }, []);

  return { isScrolling, handleScroll };
};

// Extend window interface for TypeScript
declare global {
  interface Window {
    scrollIndicatorTimeout: NodeJS.Timeout;
    scrollTimeout: NodeJS.Timeout;
  }
}